export default "__VITE_ASSET__d5b06ddb__"